module.exports = __webpack_public_path__ + "static/img/hongzao.a4080ea1.png";